import styles from '@features/contracts/additionalContracts/AdditionalContractStyles.module.scss'
import { ModalWS, ModalWSBackButton } from '@/components/ModalWS'
import React from 'react'
import { Title } from '@/ui'
import { SocialEarlyExitForm } from '@features/contracts/socialLeaves/form/SocialEarlyExitForm'
import { useTranslation } from 'react-i18next'


export const EarlyExitSocialLeaveModal = ({onClose, socialLeave, page, pageSize, filters}) => {
	const { t } = useTranslation()

	return (
		<ModalWS show={true} windowClassName={styles.modalWS}>
			<ModalWSBackButton onClick={onClose} />
			<div className={`scroll`}>
				<Title className={styles.title}>
					{t('social_leave.form.earlyExit.registration')}
				</Title>

				<SocialEarlyExitForm socialLeave={socialLeave} onClose={onClose} page={page} pageSize={pageSize} filters={filters}/>
			</div>
		</ModalWS>
	)
}